import {Component, OnInit, VERSION, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Observable, Subscription} from 'rxjs';
import { convertBooleanToNumbers, convertNumberToBoolean, isHostDevOrLocal, isNullOrUndefOrEmpty } from "app/common";
import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {LazyImage} from "../../../components/lazy-image/lazy-image";
import {
    ExperienceLevelType,
    IAccessTable,
    IAppSettingsWrap,
    IAppStatic,
    ICRUDCommand,
    ICRUDRecord,
    IOS,
    IPreferenceKeys,
    IPreferencesBusiness,
    IUser
} from "../../../interfaces";
import {faAngular} from "@fortawesome/free-brands-svg-icons";
import {AccessService, AppService, AuthUserService, LocalStoreService, StoreSelectorsService} from "../../../services";
import {TranslocoService} from "@ngneat/transloco";
import {actionAccountCommandsRequest, actionPreferenceUpdateStore} from "../../../store/actions/user.actions";
import {ToastrService} from "ngx-toastr";
import {filter, map} from "rxjs/operators";
import {Compbaser} from "../../../components/compbaser";
import jdenticon from 'jdenticon';
import {Lib} from "../../../../libs/Lib";
import {IGroupCollection} from "../../../interfaces/enterprise-interface";
import {ActivatedRoute} from "@angular/router";

const {version: appVersion} = require('../../../../../package.json');
const {cloudVersion: cloudVersion} = require('../../../../../package.json');
const noPermissionRequired = ['paintEnabled', 'sceneOpacityLevel', 'restartPlayer', 'saveSceneTimer', 'saveSceneManual', 'showDirections'];

(jdenticon.config as any) = {
    replaceMode: "observe"
};

@Component({
    templateUrl: './user-settings.component.html',
    styleUrls: ['./user-settings.component.scss'],
    standalone: false
})
export class UserSettingsComponent extends Compbaser implements OnInit {
    activeTabIndex = 0;
    formGroup: FormGroup;
    formGroupSettings: FormGroup;
    titleAlert = 'required';
    devMode;
    user: IUser;
    post;
    appVersion = appVersion;
    cloudVersion = cloudVersion;
    version = VERSION.full;
    screensState;
    enterpriseMode: boolean;
    faAngular = faAngular;
    appSettings: IAppStatic;
    avatar: any;
    form: FormGroup;
    model: IUser;
    os: IOS;
    avatarSrc: string | undefined;
    avatarFile: File | undefined;
    uploaded = false;
    ldapServer = '';
    privateServer = '';
    avatarTooSmall = false;
    avatarTooLarge = false;
    modelSubscription: Subscription;
    appStatic: IAppStatic;
    preferences: IPreferencesBusiness = {};
    isFullFeatures: boolean;
    accessConfig: IAccessTable;
    groupCollection: IGroupCollection;
    navTargets$: Observable<string>;
    navGlobal$: Observable<string>;
    navScene$: Observable<string>;
    navModule$: Observable<string>;
    signStudioHelp$: Observable<string>;
    isDev = isHostDevOrLocal();
    aiSettings;


    @ViewChild(LazyImage) lazyImage: LazyImage;

    protected readonly isAccessDenied = Lib.IsAccessBlocked;
    readonly experienceLevelType = ExperienceLevelType; // Expose enum to template
    experienceLevel: ExperienceLevelType;
    // canShowHelp = false;

    constructor(public override dialog: MatDialog,
                private route: ActivatedRoute,
                private storeSelector: StoreSelectorsService,
                private localStoreService: LocalStoreService,
                private formBuilder: FormBuilder,
                private authUserService: AuthUserService,
                private toastr: ToastrService,
                private appService: AppService,
                private accessService: AccessService,
                private translocoService: TranslocoService) {

        super(dialog);
        this.devMode = Lib.DevMode();
        this.navTargets$ = this.accessService.getGroupsCollection("SignStudio Settings").pipe(map((value) => value && value.$.navTargets ? value.$.navTargets : '1'));
        this.navGlobal$ = this.accessService.getGroupsCollection("SignStudio Settings").pipe(map((value) => value && value.$.navGlobal ? value.$.navGlobal : '1'));
        this.navModule$ = this.accessService.getGroupsCollection("SignStudio Settings").pipe(map((value) => value && value.$.navModule ? value.$.navModule : '1'));
        this.navScene$ = this.accessService.getGroupsCollection("SignStudio Settings").pipe(map((value) => value && value.$.navScene ? value.$.navScene : '1'));
        this.signStudioHelp$ = this.accessService.getGroupsCollection("SignStudio Help").pipe(map((value) => value && value.$.visible ? value.$.visible : '1'));

        this.cod(
            this.storeSelector.isFullFeatures().subscribe((v) => {
                this.isFullFeatures = v;
            })
        );
        this.cod(
            this.storeSelector.getOS().subscribe((i_os) => {
                this.os = i_os;
            })
        );
        this.modelSubscription = authUserService.user$
            .subscribe((item: IUser) => {
                this.model = item;
            });
        this.cod(
            this.storeSelector.getLocalStoreUpdates().subscribe((v) => {
                this.ldapServer = this.localStoreService.getStorageConfig().ldapServer;
                this.privateServer = this.localStoreService.getStorageConfig().privateServer;
            })
        );
        this.cod(
            this.storeSelector.getAppSettings()
                .subscribe((i_appSettings: IAppStatic) => {
                    this.appStatic = i_appSettings;
                })
        );
        this.cod(
            this.storeSelector.getCoreData()
                .subscribe((i_coreData: IAppSettingsWrap) => {
                    this.user = i_coreData[0];
                    this.appSettings = i_coreData[1];
                })
        );
        this.cod(
            this.storeSelector.getUser()
                .subscribe((i_user: IUser) => {
                    this.enterpriseMode = i_user.enterprise;

                    // Alon added that untill we support WL
                    // const accountVersion = Lib.GetAccountVersion(i_user);
                    // this.canShowHelp = (accountVersion == 'FREE' || accountVersion == 'PLUS' || accountVersion == 'DASH');


                })
        );
        // this.cod(
        //     this.route.paramMap.subscribe((routeParams) => {
        //         const enterprise = routeParams.get('id');
        //         if (enterprise) {
        //             this.openSearchFormDialog();
        //         }
        //     })
        // );


        this.cod(
            this.route.paramMap.subscribe((routeParams) => {
                const settingId = routeParams.get('id');
                if (settingId == 'ai') {
                    this.activeTabIndex = 1;
                }
            })
        );


        this.createForm();
        // this.setChangeValidate();
        this.cod(
            storeSelector.getUser()
                .subscribe((user: IUser) => {
                    this.user = user;
                })
        );

        this.cod(
            this.storeSelector.getLocalStoreUpdates('ILocalStorageConfig').subscribe((e) => {
                this.experienceLevel = this.localStoreService.getStorageValConfig('experienceLevel'); // Alon
                this.aiSettings = this.localStoreService.getStorageValConfig('ai'); // Alon
            })
        );
    }

    ngOnInit(): void {
        this.cod(
            this.accessService.getGroupsTable('SignStudio Settings', "settings").subscribe((v) => {
                this.accessConfig = v;
            })
        );
        this.cod(
            this.accessService.getGroupsCollection("SignStudio Settings").pipe(map((value) => value)).subscribe((v) => {
                this.groupCollection = v;
            })
        );
        this.cod(
            this.storeSelector.getPreferences()
                .subscribe((i_preferences) => {
                    if (isNullOrUndefOrEmpty(i_preferences)) return;
                    this.preferences = i_preferences;
                    Object.keys(this.preferences).forEach((i_key) => {
                        // in some cases like two factor its in preferences but notin settings so skip it
                        if (!this.formGroupSettings.controls[i_key]) {
                            return;
                        }
                        this.formGroupSettings.controls[i_key].patchValue(this.preferences[i_key].value);
                    });
                })
        );
        this.accessService.getGroupsCollection("SignStudio Settings").pipe(map((v => v)))
            .subscribe((v) => {

            });

        this.form = this.formBuilder.group({
            username: [
                '',
                [
                    Validators.minLength(2),
                    Validators.maxLength(20)
                ]
            ],
            email: [
                '',
                [
                    // Validates when control value isn't empty
                    (control: AbstractControl) => control.value ? Validators.email(control) : null
                ]
            ],
            passwordNew: [
                '',
                [
                    Validators.minLength(6),
                    Validators.maxLength(40)
                ]
            ]
        });
        this.screensState = [
            {
                value: '0',
                viewValue: this.translocoService.translate('general.always', {}, this.translocoService.getActiveLang())
            },
            {
                value: '1',
                viewValue: this.translocoService.translate('general.never', {}, this.translocoService.getActiveLang())
            }
        ];
    }

    openLink() {
        const newWin = window.open('https://angular.io/', '_blank');
    }

    createForm() {
        this.formGroupSettings = this.formBuilder.group({
            sceneOpacity: [{disabled: false, value: this.localStoreService.getStorageValConfig('sceneOpacityLevel')}],
            snapScale: [{disabled: false, value: this.localStoreService.getStorageValConfig('snapScale')}],
            sceneCheckeredBackground: [{
                disabled: false,
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('sceneCheckeredBackground'))
            }],
            showHelpEnabled: [{
                disabled: false,
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('showHelpEnabled'))
            }],
            // advancedScheduler: [{
            //     disabled: false,
            //     value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('advancedScheduler'))
            // }],
            theme: [{disabled: false, value: String(this.localStoreService.getStorageValConfig('theme'))}],
            // targetPlayer: [{disabled: false, value: String(this.localStoreService.getStorageValConfig('targetPlayer'))}],
            fasterqEnabled: [{
                disabled: false,
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('fasterqEnabled'))
            }],
            newsLetter: [{
                disabled: false,
                value: true
            }],
            autoCheckForUpdates: [{
                disabled: false,
                value: true
            }],
            largeLogo: [{
                disabled: false,
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('largeLogo'))
            }],
            showExperienceLevel: [{
                disabled: false,
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('showExperienceLevel'))
            }],
            catalogEnabled: [{
                disabled: false,
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('catalogEnabled'))
            }],
            dashboardEnabled: [{
                disabled: false,
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('dashboardEnabled'))
            }],
            scheduledEnabled: [{
                disabled: false,
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('scheduledEnabled'))
            }],
            paintEnabled: [{
                disabled: false,
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('paintEnabled'))
            }],
            eventsEnabled: [{
                disabled: false,
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('eventsEnabled'))
            }],
            iotEnabled: [{
                disabled: false,
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('iotEnabled'))
            }],
            transitionsEnabled: [{
                disabled: false,
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('transitionsEnabled'))
            }],
            musicEnabled: [{
                disabled: false,
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('musicEnabled'))
            }],
            scriptingMode: [{
                disabled: false,
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('scriptingMode'))
            }],
            saveFullFeature: [{
                disabled: false,
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('saveFullFeature'))
            }],
            enableDashboard: [{
                disabled: false,
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('enableDashboard'))
            }],
            restartPlayer: [{
                disabled: false,
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('restartPlayer'))
            }],
            restartPlayerOnSceneAssignment: [{
                disabled: false,
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('restartPlayerOnSceneAssignment'))
            }],
            saveSceneTimer: [{
                disabled: false,
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('saveSceneTimer'))
            }],
            saveSceneManual: [{
                disabled: false,
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('saveSceneManual'))
            }],
            showDirections: [{
                disabled: false,
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('showDirections'))
            }],
            stickersAsEmbedded: [{
                disabled: false,
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('stickersAsEmbedded'))
            }],
            sceneGuidelinesOpacityLevel: [{
                disabled: false,
                value: this.localStoreService.getStorageValConfig('sceneGuidelinesOpacityLevel')
            }],
            useDevServerPort: [{
                disabled: false,
                // OFF by default — checked ONLY when explicitly '1'. Matches getInitialDevPort()
                // (common/functions.ts), which now defaults to the prod port (443) and uses 9443 only
                // when useDevServerPort === '1'. convertNumberToBoolean gives '1'→true, '0'/undefined→false.
                value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('useDevServerPort'))
            }]
            // saveSceneOnExit: [{disabled: false, value: convertNumberToBoolean(this.localStoreService.getStorageValConfig('saveSceneOnExit'))}],
        });
    }

    onTogglePreference(controlName: IPreferenceKeys) {
        if (!this.preferences) return;
        const command: ICRUDCommand = this.preferences[controlName] ? 'update' : 'add';
        const saveRecord: ICRUDRecord = {
            studioId: this.localStoreService.getStorageConfig().studioId,
            command,
            primary: 'preference_id',
            table: 'preferences',
            id: command === 'update' ? this.preferences[controlName].id : null,
            body: {
                user_id: Lib.Base64().encode(this.user.username),
                preference_key: controlName,
                preference_value: {value: this.formGroupSettings.get(controlName).value},
            }
        };
        this.appService.crudRecord(saveRecord).then((i_crudReply: ICRUDRecord) => {
            if (!i_crudReply.serverReply.status) return;
            const data = {};
            data[controlName] = {
                id: command === 'update' ? this.preferences[controlName].id : i_crudReply.serverReply.id,
                value: this.formGroupSettings.get(controlName).value
            };
            this.storeSelector.dispatch(actionPreferenceUpdateStore({
                preferencesBusiness: data
            }));
        });
    }

    private static readonly PINNABLE_MODULES = [
        'paintEnabled', 'catalogEnabled', 'scheduledEnabled',
        'eventsEnabled', 'fasterqEnabled', 'dashboardEnabled'
    ];

    onToggleSettings(controlName: string) {
        if (noPermissionRequired.indexOf(controlName) === -1) {
            if (!this.accessConfig?.upd) return this.accessService.showNoAccess();
        }
        const val = convertBooleanToNumbers(this.formGroupSettings.get(controlName).value, true);
        this.localStoreService.setStorageValConfig(controlName, val);

        // Pin/unpin module so it stays visible even in basic mode
        if (UserSettingsComponent.PINNABLE_MODULES.includes(controlName)) {
            const pinned = (this.localStoreService.getStorageValConfig('pinnedModules') || '').split(',').filter(Boolean);
            if (val === '1') {
                if (!pinned.includes(controlName)) pinned.push(controlName);
            } else {
                const idx = pinned.indexOf(controlName);
                if (idx > -1) pinned.splice(idx, 1);
            }
            this.localStoreService.setStorageValConfig('pinnedModules', pinned.join(','));
        }

        // DEV_TEST_PORT is captured once at module load (global-constants.ts), so switching the dev
        // server port only takes effect after a full reload. Offer the developer a reload now. This
        // control is shown only in dev/local mode, so this prompt never appears in production.
        if (controlName === 'useDevServerPort') {
            if (window.confirm('Dev server port changed. Would you like to reload studio now to apply the change?')) {
                window.location.reload();
            }
        }
    }

    // onTargetPlayerChanged(e) {
    //     if (!this.accessConfig?.upd) return this.accessService.showNoAccess();
    //     this.localStoreService.setStorageValConfig('targetPlayer', e.value);
    // }

    onChangeOpacity(e) {
        if (!this.accessConfig?.upd) return this.accessService.showNoAccess();
        this.localStoreService.setStorageValConfig('sceneOpacityLevel', e.value);
    }

    onChangeSnapScale(e) {
        this.localStoreService.setStorageValConfig('snapScale', e.value);
    }

    onChangeSceneGuidelinesOpacity(e) {
        if (!this.accessConfig?.upd) return this.accessService.showNoAccess();
        this.localStoreService.setStorageValConfig('sceneGuidelinesOpacityLevel', e.value);
    }


    onForceLogout() {
        this.localStoreService.clearStorage();
        this.authUserService.logout();
        this.appService.goToHomePage(false);
    }

    onReloadAccountData() {
        if (!this.accessConfig?.upd) return this.accessService.showNoAccess();
        this.toastr.info(this.translocoService.translate('general.refreshingUserInfo', {}, this.translocoService.getActiveLang()));
        this.storeSelector.appStore.dispatch(actionAccountCommandsRequest({
                accountRequest: {
                    verifyAccount: {
                        userName: this.user.username,
                        password: this.user.passwordNew,
                        rememberMe: this.user.rememberMe
                    },
                    serverCall: "SYNC_USER"
                }
            })
        );
    }

    resetBlinking(event) {
        this.localStoreService.setStorageValConfigGroup([
            {key: 'watchedVideoLinks', val: {}},
            {key: 'lessonVideoId', val: null},
            {key: 'globalVideoId', val: null}
        ]);

        this.toastr.info('reset blinking buttons', '');
        event.stopPropagation();
        event.stopImmediatePropagation();
    }

    isResetBlinkingEnabled() {
        return convertNumberToBoolean(this.localStoreService.getStorageValConfig('showHelpEnabled'));
    }

    onSubmit(event) {
        if (!this.accessConfig?.upd) return this.accessService.showNoAccess();
        if (this.formGroup.valid) {
            this.post = JSON.stringify(this.formGroup.value);
            return console.log(this.formGroup.value);
        } else {
            this.validateAllFormFields(this.formGroup);
        }
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            control.markAsTouched({onlySelf: true});
        });
    }

    onAiSettingsChange(aiSettings: any) {
        this.aiSettings = aiSettings;
        this.localStoreService.setStorageValConfig('ai', this.aiSettings);
    }

    testError() {
        throw new Error('Foo Bar error ' + Math.random());
    }

    override destroy() {
        super.destroy();
        this.modelSubscription.unsubscribe();
    }
}

// openSearchFormDialog(data: any): MatDialogRef<UserSearchDialogComponent> {
//   return this.dialog.open(UserSearchDialogComponent, {data});
// }

// searchUser(): void {
//   const dialogRef = this.openSearchFormDialog({
//     model: this.user,
//     callback: (): void => {
//       // this.userStore.fetchData();
//       dialogRef.close();
//     }
//   });
// }


// get avatarInvalid(): boolean {
//     return this.avatarTooSmall || this.avatarTooLarge;
// }

// get username(): AbstractControl {
//     return this.form.get('username');
// }

// get email(): AbstractControl {
//     return this.form.get('email');
// }

// get passwordNew(): AbstractControl {
//     return this.form.get('passwordNew');
// }


// selectAvatar(files: FileList): void {
//     const file: File | undefined = files[0];
//     this.avatarFile = file;
//     this.uploaded = false;
//
//     if (file) {
//         const reader = new FileReader();
//
//         /**
//          * Is there a better solution?
//          * @see https://github.com/Microsoft/TypeScript/issues/299#issuecomment-168538829
//          */
//         reader.onload = (e: Event) => {
//             this.avatarSrc = e.target['result'];
//         };
//         reader.readAsDataURL(file);
//         this.avatarTooSmall = file.size < 100;
//         this.avatarTooLarge = file.size > 1024 * 200;
//     } else {
//         this.avatarSrc = undefined;
//         this.avatarTooSmall = false;
//         this.avatarTooLarge = false;
//     }
// }

// updateAvatar(): void {
//     this.userStore.updateAvatar(this.model, this.avatarFile)
//       .subscribe((data: ResponseData) => {
//         if (dataIsSuccess(data)) {
//           this.authUserService.replace({
//             ...this.model,
//             ...data.data
//           });
//           this.uploaded = true;
//           this.showMessage('Avatar update successful!');
//         }
//       }, (errorResp: HttpErrorResponse) => {
//         if (errorResp.status === 422) {
//           const error: ErrorMessage | undefined = errorResp.error.data.find(
//             (errorMessage: ErrorMessage) => errorMessage.field === 'avatarFile'
//           );
//           if (error) {
//             this.showMessage(error.message);
//           }
//         }
//       });
// }

// updateUsername() {
//     if (!this.accessConfig?.upd) return this.accessService.showNoAccess();
//     this.updateField('username');
// }
//
// updateEmail(): void {
//     this.updateField('email');
// }
//
// updatePassword() {
//     if (!this.accessConfig?.upd) return this.accessService.showNoAccess();
//     this.updateField('passwordNew');
// }

// updateField(field: 'username' | 'email' | 'passwordNew'): void {
// this.userStore.update({
//   ...this.model,
//   [field]: this[field].value
// }).subscribe((data: ResponseData) => {
//   if (dataIsSuccess(data)) {
//     this.authUserService.replace({
//       ...this.model,
//       ...data.data
//     });
//     this[field].reset();
//     this.showMessage('Update completed!');
//   }
// }, (errorResp: HttpErrorResponse) => {
//   if (errorResp.status === 422) {
//     errorResp.error.data.forEach((errorMessage: ErrorMessage) => {
//       this.form.get(errorMessage.field).setErrors({
//         message: errorMessage.message
//       });
//     });
//   }
// });
// }

// showMessage(message: string, action: string = 'Close'): void {
//     this.snackBar.open(message, action, {
//         duration: 4000,
//     });
// }

// updateForm() {
//     if (!this.accessConfig?.upd) return this.accessService.showNoAccess();
//     this.formGroup.controls['email'].patchValue(this.user.email);
//     this.formGroup.controls['name'].patchValue(this.user.name);
//     this.formGroup.controls['password'].patchValue(this.user.passwordNew);
//     this.formGroup.controls['description'].patchValue(this.user.description);
//     this.formGroup.controls['createTimeEnd'].patchValue(this.user.updatedAt == 0 || this.user.updatedAt == '' ? new Date(2022, 0, 1, 10, 33, 30, 0).toISOString() : new Date(this.user.updatedAt));
// }
//
// checkInUseEmail(control) {
//     const db = ['test@example.com'];
//     return new Observable(observer => {
//         setTimeout(() => {
//             const result = (db.indexOf(control.value) !== -1) ? {'alreadyInUse': true} : null;
//             observer.next(result);
//             observer.complete();
//         }, 4000);
//     });
// }

// get name() {
//     return this.formGroup.get('name') as FormControl;
// }


// checkPassword(control) {
//     const enteredPassword = control.value;
//     const passwordCheck = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
//     return (!passwordCheck.test(enteredPassword) && enteredPassword) ? {'requirements': true} : null;
// }
//
// getErrorEmail() {
//     return this.formGroup.get('email').hasError('required') ? 'Field is required' :
//         this.formGroup.get('email').hasError('pattern') ? 'Not a valid email' :
//             this.formGroup.get('email').hasError('alreadyInUse') ? 'email already in use' : '';
// }
//
// getErrorPassword() {
//     return this.formGroup.get('password').hasError('required') ? 'Field is required (8+ char uppercase and number)' :
//         this.formGroup.get('password').hasError('requirements') ? 'password not strong enough' : '';
// }

// createUser() {
//     if (!this.accessConfig.add) return this.accessService.showNoAccess();
//     const dialogRef = this.openFormDialog({
//         title: 'Create User',
//         model: this.user,
//         scenario: SCENARIO_CREATE,
//         callback: (): void => {
//             // this.userStore.fetchData();
//             dialogRef.close();
//         }
//     });
// }

// openFormDialog(data: any): MatDialogRef<UserFormDialogComponent> {
//     return this.dialog.open(UserFormDialogComponent, {data});
// }

// deleteUser() {
//     if (!this.accessConfig.del) return this.accessService.showNoAccess();
//     const dialogRef = this.openDeletionDialog({
//         model: this.user,
//         callback: (): void => {
//             // this.userStore.fetchData();
//             dialogRef.close();
//         }
//     });
// }

// openDeletionDialog(data: any): MatDialogRef<UserDeletionDialogComponent> {
//     return this.dialog.open(UserDeletionDialogComponent, {data});
// }


// const emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// this.formGroup = this.formBuilder.group({
//     email: [{disabled: true, value: ''}, [Validators.required, Validators.pattern(emailregex)], this.checkInUseEmail],
//     name: [{disabled: false, value: ''}, Validators.required],
//     password: [{disabled: true, value: ''}, [Validators.required, this.checkPassword]],
//     description: [{disabled: true, value: ''}, [Validators.required, Validators.minLength(5), Validators.maxLength(50)]],
//     createTimeEnd: [{disabled: false, value: new Date().toISOString()}],
//     validate: ''
// });
// setChangeValidate() {
//     this.formGroup.get('validate').valueChanges.subscribe(
//         (validate) => {
//             if (validate) {
//                 this.formGroup.get('createTimeEnd').setValidators([Validators.required, Validators.minLength(3)]);
//                 this.titleAlert = "You need to specify at least 3 characters";
//             } else {
//                 this.formGroup.get('createTimeEnd').setValidators(null);
//             }
//             this.formGroup.get('createTimeEnd').updateValueAndValidity();
//         }
//     );
// }
